import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.accountInfo ? _c("a-dropdown", {
    staticClass: "navUser-wrppaer"
  }, [_c("div", [_c("img", {
    staticClass: "userImg",
    attrs: {
      src: require("../../../assets/nav/user.png"),
      alt: ""
    }
  }), _c("span", {
    staticClass: "userTitle"
  }, [_vm._v(_vm._s(_vm.accountInfo.nickName))]), _c("a-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      type: "caret-down"
    }
  })], 1), _c("a-menu", {
    attrs: {
      slot: "overlay"
    },
    slot: "overlay"
  }, [_vm.accountInfo.multipleAccountInfo.length != 0 ? _c("a-menu-item", {
    staticClass: "infoBox"
  }, [_c("div", {
    staticClass: "info"
  }, [_c("img", {
    staticClass: "userImg",
    attrs: {
      src: require("../../../assets/nav/user.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "uderInfo"
  }, [_c("div", {
    staticClass: "name-info"
  }, [_c("span", {
    staticStyle: {
      "font-weight": "700",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.accountInfo.nickName))]), _c("span", {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.accountInfo.account))])]), _c("div", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_vm.accountInfo.isSuper === 1 ? _c("a-tag", {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      color: "blue"
    }
  }, [_vm._v(_vm._s(_vm.$t("超级管理员")))]) : _vm._e(), _vm._l(_vm.accountInfo.roles, function (item, index) {
    return _c("a-tag", {
      key: index,
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        color: "blue"
      }
    }, [_vm._v(_vm._s(item.name))]);
  })], 2)])])]) : _vm._e(), _c("a-menu-item", {
    staticClass: "infoBox2"
  }, [_c("div", {
    staticClass: "btn",
    on: {
      click: function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.$router.push({
          name: "personalCenter",
          params: {
            id: _vm.accountInfo.id
          }
        });
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("个人中心")) + " ")]), _vm.accountInfo.customerId > 0 ? _c("div", {
    staticClass: "btn",
    on: {
      click: _vm.closeAccountCli
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("注销账号")) + " ")]) : _vm._e(), _vm.accountInfo.multipleAccountInfo.length != 0 ? _c("div", {
    staticClass: "btn",
    on: {
      click: function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.logout.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("切换账号")) + " ")]) : _vm._e(), _c("div", {
    staticClass: "btn",
    on: {
      click: function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.logout.apply(null, arguments);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("退出登录")))])])], 1)], 1) : _vm._e(), _c("closeAccountModal", {
    attrs: {
      visibleModal: _vm.visibleModal
    },
    on: {
      "update:visibleModal": function ($event) {
        _vm.visibleModal = $event;
      },
      "update:visible-modal": function ($event) {
        _vm.visibleModal = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };